import { useEffect, useRef } from "react";
import styles from "./Valpay.module.css";
import "@adyen/adyen-web/dist/adyen.css";
import classNames from "classnames";

function PaymentMethods({ className, valpayObj }): JSX.Element | null {
  const containerRef = useRef();

  useEffect(() => {
    // Only initiate ValPay if we are ready to do so.
    if (!valpayObj) return;
    valpayObj.mount(containerRef.current);
  }, [valpayObj]);

  return <div className={classNames(className, styles.dropin)} ref={containerRef} />;
}

export default PaymentMethods;
